import type { LineRole, PaperLine } from "../types";

const MAJOR_SECTIONS = new Set([
  "introduction",
  "methods",
  "results",
  "discussion",
  "conclusion",
  "conclusions",
  "references",
  "acknowledgements",
  "acknowledgments",
  "data availability",
  "supplementary material",
  "supplementary materials",
  "supplementary information",
  "funding",
  "competing interests",
  "author contributions",
  "ethics",
  "limitations",
  "background",
  "related work",
  "abstract",
]);

export const classifyLine = (
  line: PaperLine,
  index: number,
  allLines: PaperLine[],
  titleText: string
): LineRole => {
  const t = line.text.trim();
  const lower = t.toLowerCase();

  if (index === 0 && titleText && lower === titleText.toLowerCase()) return "title";

  if (/^\[\d+\]\s/.test(t)) return "reference";

  if (/^(?:Figure|Fig\.?)\s+\d+/i.test(t)) return "figure_caption";
  if (/^Table\s+\d+/i.test(t)) return "table_caption";
  if (/^(Supplementary|Supp\.?)\s+(Figure|Table|Fig\.?)\s+\S/i.test(t)) return "figure_caption";

  if (/^DOI:\s/i.test(t)) return "meta";
  if (/^(Received|Accepted|Rev-Recd|Published):\s/i.test(t)) return "meta";
  if (/^https?:\/\//i.test(t)) return "meta";

  if (index <= 1) return "title";
  if (index >= 2 && index <= 4 && /^\d+\s+\w/.test(t)) return "affiliation";
  if (index >= 2 && index <= 5 && t.length > 20 && /[,*†]/.test(t)) return "authors";

  if (MAJOR_SECTIONS.has(lower) || MAJOR_SECTIONS.has(lower.replace(/\s+$/, ""))) {
    return "major_heading";
  }

  const isShort = t.length < 80;
  const noTrailingPunct = !/[.;,!?)]$/.test(t);
  const noCitation = !/\[\s*\d+\s*\]/.test(t);
  const startsUpper = /^[A-Z]/.test(t);
  const notNumbered = !/^\d/.test(t);
  const nextLine = allLines[index + 1];
  const nextIsLonger = nextLine && nextLine.text.trim().length > 80;

  if (isShort && noTrailingPunct && noCitation && startsUpper && notNumbered && nextIsLonger) {
    return "minor_heading";
  }

  return "body";
};
